<lib-messages   [mode]="2" [messageTitle]="translationData?.sorry || 'Sorry !'"
[optionalMessage]="message">
<ng-template #content>
  <div class="lower-section">
    <button [routerLink]="workspaceLink" type="button" 
    aria-label="Go To Workspace"
    class="btn btn-primary mx-auto d-block">
      {{ translationData?.goToWorkspace || "Go To Workspace" }}
    </button>
  </div>
</ng-template>
</lib-messages> 